"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.resetTests = exports.getTestContext = exports.ActivityWatcher = void 0;var _logging = require("./utils/logging");
var _const = require("./const");




/**
 * An array of DOM events that should be interpreted as user activity.
 * @type {string[]}
 */
const activityEvents = [
'mousedown', 'mousemove', 'keydown',
'scroll', 'touchstart'];












let initialized = false;
let lastActivityDate = Date.now();
let isActive = false;
let inactiveMinutes = _const.DEFAULT_INACTIVE_MINUTES;
let inactiveWarningMinutes = _const.DEFAULT_WARNING_MINUTES;
let warningTriggered;
let intervalId;
let previousWarnState, previousActiveState;
let callbackFunctions;

class ActivityWatcher {

  static get initialized() {return initialized;}

  static get isActive() {return isActive;}

  static get pollInterval() {return _const.POLL_INTERVAL_ACTIVITY_SECONDS;}

  static get inactiveMinutes() {return inactiveMinutes;}

  static get inactiveWarningMinutes() {return inactiveWarningMinutes;}

  static init(callbackFns) {
    if (initialized) return;

    callbackFunctions = callbackFns;

    //add these events to the document.
    //register the activity function as the listener parameter.
    activityEvents.forEach(function (eventName) {
      document.addEventListener(eventName, () => {
        /* istanbul ignore next */
        lastActivityDate = Date.now();
      }, true);
    });

    initialized = true;
  }

  /**
   * Starts the activity timer
   */
  static start(inactiveInMinutes = _const.DEFAULT_INACTIVE_MINUTES, inactiveWarningInMinutes = _const.DEFAULT_WARNING_MINUTES) {
    if (intervalId) {
      ActivityWatcher.stop();
    }
    inactiveMinutes = inactiveInMinutes;
    inactiveWarningMinutes = inactiveWarningInMinutes;
    intervalId = setInterval(ActivityWatcher.intervalFn, _const.POLL_INTERVAL_ACTIVITY_SECONDS * 1000);
  }

  static stop() {
    clearInterval(intervalId);
    intervalId = undefined;
    isActive = false;
    warningTriggered = undefined;
    previousActiveState = undefined;
    previousWarnState = undefined;
  }

  static intervalFn() {
    ActivityWatcher.activityFn();
    ActivityWatcher.warningFn();
  }

  /***
   * Evaluates the user's Activity status
   */
  static activityFn() {
    const { onActiveIntervalCallback, onInactiveIntervalCallback } = callbackFunctions;
    const secondsSinceLastActivity = Math.round((Date.now() - lastActivityDate) / 1000);
    isActive = secondsSinceLastActivity < inactiveMinutes * 60;

    if (isActive !== previousActiveState) {
      _logging.Logger.debug(secondsSinceLastActivity + ' seconds since the user was last active', ` (Active: ${isActive})`);
      previousActiveState = isActive;
    }

    //User is active
    if (onActiveIntervalCallback && isActive) {
      //Reset the trigger if the time elapsed since last time is equal/greater to the "warning minutes"
      if (new Date().getTime() - warningTriggered >= inactiveWarningMinutes * 60 * 1000) {
        warningTriggered = undefined;
      }
      onActiveIntervalCallback();
    }

    //User is inactive
    if (onInactiveIntervalCallback && !isActive) {
      onInactiveIntervalCallback(secondsSinceLastActivity);
    }
  }

  static warningFn() {
    if (warningTriggered) return;

    const secondsSinceLastActivity = Math.round((Date.now() - lastActivityDate) / 1000);
    const logoutSeconds = inactiveMinutes * 60 - secondsSinceLastActivity;
    const shouldWarn = logoutSeconds <= inactiveWarningMinutes * 60;

    if (shouldWarn !== previousWarnState) {
      _logging.Logger.debug(`Has warnings: ${shouldWarn}`, ` (Logout Seconds: ${logoutSeconds})`);
      previousWarnState = shouldWarn;
    }

    if (callbackFunctions.onLogoutWarningCallback && shouldWarn) {
      warningTriggered = new Date().getTime();
      callbackFunctions.onLogoutWarningCallback(logoutSeconds);
    }
  }
}exports.ActivityWatcher = ActivityWatcher;

const resetTests = () => {
  initialized = false;
  ActivityWatcher.stop();
  inactiveMinutes = _const.DEFAULT_INACTIVE_MINUTES;
  inactiveWarningMinutes = _const.DEFAULT_WARNING_MINUTES;
  warningTriggered = false;
};exports.resetTests = resetTests;

const getTestContext = () => {
  return {
    activityEvents,
    intervalId,
    setLastActivityDate: function (date) {lastActivityDate = date;},
    setWarningTriggeredDate: function (date) {warningTriggered = date;},
    warningTriggered
  };
};exports.getTestContext = getTestContext;